import "devextreme/dist/css/dx.common.css";
import "./themes/generated/theme.base.css";
import "./themes/generated/theme.additional.css";
// import "./v1/assets/styles/global.scss";
import "./assets/styles/variables.base.scss";
import "./assets/styles/gc-overrides.scss";
import "./assets/fontawesome/css/all.css";
import "./_helpers/default-options";

import "./assets/styles/syncfusion.scss";

import Vue from "vue";
import Vue2Filters from "vue2-filters";
Vue.use(Vue2Filters);

import { store } from "./_store";
// eslint-disable-next-line no-unused-vars
import { NumberPrototype } from "./_helpers/prototypes/prototype-number";
// eslint-disable-next-line no-unused-vars
import { StringPrototype } from "./_helpers/prototypes/prototype-string";
// eslint-disable-next-line no-unused-vars
import { DatePrototype } from "./_helpers/prototypes/prototype-date";
// eslint-disable-next-line no-unused-vars
import { ArrayPrototype } from "./_helpers/prototypes/prototype-array";

import Logger from "./_services/logging";
Vue.use(Logger);

// import GlobalButtonClick from "./_services/logging";
// Vue.use(GlobalButtonClick);

import App from "./App";
import router from "./router";
import appInfo from "./app-info";

import GcMainLayout from "./v1/layouts/gc-main-layout";
import GcBaseLayout from "./layouts/gc-base-layout";
import GcSecondaryLayout from "./v1/layouts/gc-secondary-layout";

import { RegisterBaseComponents } from "./components/global-components";
import { RegisterPopUpComponents } from "./popups/global-popups";
import { RegisterV1BaseComponents } from "./v1/components/global-components";
import { RegisterSyncfusionComponents } from "./components/syncfusion-components";
import { CommonStorage } from "./_services/storage";
import "./registerServiceWorker";

RegisterBaseComponents();
RegisterPopUpComponents();
RegisterV1BaseComponents();
RegisterSyncfusionComponents();

Vue.config.productionTip = false;
Vue.prototype.$appInfo = appInfo;

// register the layout globally so that we do not need to import within pages explicitly
Vue.component("GcMainLayout", GcMainLayout);
Vue.component("GcBaseLayout", GcBaseLayout);
Vue.component("GcSecondaryLayout", GcSecondaryLayout);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// Check if the browser supports service workers
// if ('serviceWorker' in navigator) {
//   // Add an event listener for the 'load' event
//   // This event is fired when the whole page has loaded, including all dependent resources such as stylesheets and images
//   window.addEventListener('load', () => {
//     // Register the service worker
//     navigator.serviceWorker.register('/service-worker.js')
//       .then(registration => {
//         // If the registration is successful, log the registration scope
//         // eslint-disable-next-line no-console
//         console.log('Service Worker registered with scope:', registration.scope);
//       })
//       .catch(error => {
//         // If the registration fails, log the error
//         // eslint-disable-next-line no-console
//         console.error('Service Worker registration failed:', error);
//       });
//   });
// }

// Create a new BroadcastChannel object
const broadcastChannel = new BroadcastChannel("session-channel");

// Define a function to notify the service worker of user activity
function notifyServiceWorkerOfActivity() {
  // Check if the browser supports service workers
  if ("serviceWorker" in navigator) {
    if (CommonStorage.getItems("TriggerSessionLogOutOnTabOpen") == "true") {
      if (
        router &&
        router.history &&
        router.history.current.name != "login-form"
      ) {
        store.dispatch("authentication/logout");
        CommonStorage.saveItems("APP_SESSION_TIME_OUT", true);
      }
    }
    // Send a message to the service worker with the action 'user_activity' and the session timeout duration
    else
      broadcastChannel.postMessage({
        action: "user_activity",
        time_out: CommonStorage.getItems("SessionTimeOutInMinutes"),
      });
  }
}

// Add event listeners for user activity events (e.g., clicks, keypresses, keydowns, wheel events)
// When these events are fired, notify the service worker of user activity
document.addEventListener("click", notifyServiceWorkerOfActivity);
document.addEventListener("keypress", notifyServiceWorkerOfActivity);
document.addEventListener("keydown", notifyServiceWorkerOfActivity);
document.addEventListener("wheel", notifyServiceWorkerOfActivity);

// Add an event listener for the 'message' event on the broadcast channel
broadcastChannel.onmessage = (event) => {
  // If a message is received and the action is 'session_timeout'
  if (event.data && event.data.action === "session_timeout") {
    // Perform actions for session timeout, such as auto logout
    // Display a message or initiate the logout process
    // alert('Your session has timed out. Please log in again.'); // Display an alert
    // // Notify the service worker of user activity
    // notifyServiceWorkerOfActivity();

    if (
      router &&
      router.history &&
      router.history.current.name != "login-form"
    ) {
      store.dispatch("authentication/logout");

      CommonStorage.saveSessionItem("APP_SESSION_TIME_OUT", true);
      if (event.data.message) {
        CommonStorage.saveSessionItem(
          "APP_SESSION_TIME_OUT_MESSAGE",
          event.data.message
        );
      }
    } else {
      notifyServiceWorkerOfActivity();
    }
  }

  if (event.data && event.data.action == "version_logout") {
    if (
      router &&
      router.history &&
      router.history.current.name != "login-form"
    ) {
      store.dispatch("authentication/logout");
      CommonStorage.saveItems("APP_VERSION_CHECK", true);
    }
  }

  if (event.data && event.data.action == "login_success") {
    if (
      router &&
      router.history &&
      router.history.current.name == "login-form"
    ) {
      CommonStorage.saveSessionItem("APP_SESSION_TIME_OUT", false);
      CommonStorage.clearSessionItem("APP_SESSION_TIME_OUT_MESSAGE");
      location.reload();
    }
  }

  if (event.data && event.data.action == "last_session-reset") {
    CommonStorage.saveItems("LastSessionReset", event.data.value);
  }
};

if ("serviceWorker" in navigator) {
  let getVersionTimeOut = CommonStorage.getItems(
    "VersionCheckerTimerInMinutes"
  );

  if (getVersionTimeOut) {
    setTimeout(() => {
      broadcastChannel.postMessage({
        action: "version_interval",
        value: getVersionTimeOut * 60 * 1000,
      });
    }, 1000);
  }

  var LastSessionReset = CommonStorage.getItems("LastSessionReset");
  if (LastSessionReset) {
    let getSessionTimeOutInMinutes = CommonStorage.getItems(
      "SessionTimeOutInMinutes"
    );

    if (getSessionTimeOutInMinutes) {
      const currentTime = Date.now();
      const elapsedTime = currentTime - LastSessionReset;
      const elapsedMinutes = elapsedTime / 1000 / 60;

      if (elapsedMinutes >= getSessionTimeOutInMinutes) {
        // CommonStorage.saveItems("TriggerSessionLogOutOnTabOpen", true);
        if (
          router &&
          router.history &&
          router.history.current.name != "login-form"
        ) {
          setTimeout(() => {
            store.dispatch("authentication/logout");
            CommonStorage.saveItems("APP_SESSION_TIME_OUT", true);
          }, 1000);
        }
      }
    }
  }
}
